module.exports = __webpack_public_path__ + "static/media/10.f08d7f76.png";